import { render, staticRenderFns } from "./payment-summary.vue?vue&type=template&id=bea63b70&scoped=true"
import script from "./payment-summary.vue?vue&type=script&lang=ts"
export * from "./payment-summary.vue?vue&type=script&lang=ts"
import style0 from "./payment-summary.vue?vue&type=style&index=0&id=bea63b70&prod&lang=postcss&media=print&scoped=true"
import style1 from "./payment-summary.vue?vue&type=style&index=1&id=bea63b70&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bea63b70",
  null
  
)

export default component.exports